// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="september-21-2021">September 21, 2021</h3>
      <p>We added new elements and values to the R4 <code>Condition</code> FHIR mapping.</p>
      <ul>
      <li>The <code>clinicalStatus</code> element now supports the value <code>inactive</code>.</li>
      <li>The <code>verificationStatus</code> element now returns these additional values:<code>provisional</code>, <code>differential</code>, <code>confirmed</code>, and <code>refuted</code>. Previously, this element always returned  <code>unconfirmed</code>.</li>
      <li>The <code>recorder</code> element is now added.</li>
      </ul>
      <p>The R4 <code>AllergyIntolerance</code> FHIR mapping now includes both <code>clincalStatus</code> and <code>verificationStatus</code>.  Previously, only one was populated based on value.</p>
      <p>The <code>primarySource</code> for the R4 <code>Immunization</code> FHIR mapping now supports Boolean values. Previously, it was always <code>true</code>.</p>
      <hr />
      <h3 id="august-24-2021">August 24, 2021</h3>
      <p>Added the <code>code</code> data to the R4 <code>AllergyIntolerance</code> resource to be compliant with <a href="http://hl7.org/fhir/us/core/StructureDefinition-us-core-allergyintolerance.html">US Core Implementation Guide</a>.</p>
      <p>Updated the <code>Condition</code> resource to include <a href="http://snomed.info/sct">SNOMED CT</a> and ICD-10-CM codings when both are available.</p>
      <hr />
      <h3 id="may-4-2021">May 4, 2021</h3>
      <p>Added an <code>identifier</code> to the <code>Organization</code> resource to represent the VA Facility to be consistent with the Facility ID used by the Facilities API. For example a VAMC has an identifier of the form <code>vha_[stationNumber]</code> like <code>vha_673</code>.</p>
      <p>Added an <code>identifier</code> to the <code>Location</code> resource to represent the VA clinic. This <code>identifier</code> has the form <code>vha_[stationNumber]_[clinic identifier]</code>.</p>
      <hr />
      <h3 id="february-24-2021">February 24, 2021</h3>
      <p>Added the FHIR R4 resource <code>Appointment</code>, which includes the ability to search appointments by <code>Patient</code> and <code>Location</code> references and searching by <code>_lastUpdated</code> date.</p>
      <hr />
      <h3 id="december-15-2020">December 15, 2020</h3>
      <p>The following three R4 resources have been made available: <code>Device</code>, <code>Practitioner</code>, and <code>PractitionerRole</code>. Not all US Core searches are yet supported for <code>Practitioner</code> and <code>PractitionerRole</code>.</p>
      <p>The hold times for <code>Immunization</code> and COVID 19 Lab Results have been eliminated.</p>
      <hr />
      <h3 id="august-31-2020">August 31, 2020</h3>
      <p>In adherence to changes per the <a href="https://www.federalregister.gov/documents/2020/05/01/2020-07419/21st-century-cures-act-interoperability-information-blocking-and-the-onc-health-it-certification#h-13">21st Century Cures Act</a>, the Veteran Health API profile, in line with the US Core Implementation Guide has added FHIR R4 resources to the R4 tab.</p>
      <hr />
      <h3 id="august-7-2020">August 7, 2020</h3>
      <p>We have updated the mock health records for test users in the Sandbox environment for the Veterans Health API <code>Condition</code> resource to list conditions from either SNOMED-CT or ICD-10 code sets.  Previously only SNOMED-CT codes were available.</p>
      <hr />
      <h3 id="july-31-2020">July 31, 2020</h3>
      <p>We are decreasing the data hold time for the Veterans Health API from 72 hours to 36 hours, effective July 31, 2020, based on an updated VHA policy.  When a physician enters or changes patient data, there is a holding period before the data is released and visible through other applications such as health apps. The holding period gives physicians time to contact their patients and discuss health data, such as sensitive diagnoses, before the patient sees this data elsewhere. This change applies only to real data entered into the production environment.</p>
      <hr />
      <h3 id="july-13-2020">July 13, 2020</h3>
      <p>The CoverageEligibilityResponse resource for Urgent Care is deprecated and scheduled for deactivation in the 3rd quarter of 2020.<br />
      We are working on new FHIR R4 resources and will add those in the 3rd quarter of 2020.</p>
      <hr />
      <h3 id="june-10-2020-fhir">June 10, 2020</h3>
      <p>The optional query parameter <code>prompt</code> has been added to the authorization flow.</p>
      <ul>
      <li>Supported prompts: login. If specified, the user will be forced to provide credentials regardless of session state. If omitted, an existing active session with the identity provider may not require the user to provide credentials.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-saml-proxy/pull/111">View code changes(s)</a></p>
      <hr />
      <h3 id="december-4-2018">December 4, 2018</h3>
      <p>Launch of the Veterans Health API</p>
      <ul>
      <li>Available for development environment access.</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
